import React from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import Fade from '@mui/material/Fade';

import Button from '@ts-core/components/Button';

import { useStudentAuth } from 'modules/account/hooks';

import TermsAndConditions from '../TermsAndConditions';

const TermsAndConditionsDialog = () => {
  const { user, onAcceptTermsAndConditions, acceptTermsAndConditionsLoading } = useStudentAuth();
  const intl = useIntl();

  return (
    <Dialog
      open={user?.mustAcceptTermsAndConditions || false}
      scroll="paper"
      sx={(theme) => ({
        '& .MuiDialog-paper': {
          [theme.breakpoints.up('sm')]: {
            maxWidth: 800,
          },
          [theme.breakpoints.up('lg')]: {
            maxWidth: 1000,
          },
          [theme.breakpoints.up('xl')]: {
            maxWidth: 1200,
          },
        },
      })}
    >
      <AppBar sx={{ position: 'relative', mb: 0 }}>
        <Toolbar>
          <Typography variant="h6" color="inherit" sx={{ flex: 1 }}>
            CHECK TÉRMINOS Y CONDICIONES
          </Typography>
        </Toolbar>
        <Box>
          <Fade
            in={acceptTermsAndConditionsLoading}
            style={{
              transitionDelay: acceptTermsAndConditionsLoading ? '300ms' : '0ms',
            }}
            unmountOnExit
          >
            <LinearProgress />
          </Fade>
        </Box>
      </AppBar>
      <DialogContent>
        <TermsAndConditions />
      </DialogContent>
      <DialogActions>
        <Button loading={acceptTermsAndConditionsLoading} variant="contained" color="primary" onClick={onAcceptTermsAndConditions}>
          {intl.formatMessage({ id: 'button.accept' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsAndConditionsDialog;
